import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=b13e6800&scoped=true&"
import script from "./NoticeModal.vue?vue&type=script&lang=js&"
export * from "./NoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&id=b13e6800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e6800",
  null
  
)

export default component.exports